import React from "react";
import { Button, Icon } from "react-onsenui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera, faPlus, faSync } from "@fortawesome/free-solid-svg-icons";

const Stage3Content = ({ claim, setUploadType, setDocName, setCameraModalVis, handleDocPreview, setPreviewDocModal, setFocusedExtraImageID }) => {
  return (
    <div>
      {/* Header Section */}
      <div style={{ padding: "20px", backgroundColor: "#5C7232", color: "#fff" }}>
        <h2 style={{ fontSize: "26px", fontWeight: "600" }}>वन क्षेत्र का सीमांकन</h2>
      </div>

      {/* Form 8 Section */}
      <div style={{ borderTop: "1px solid #fff", padding: "20px" }}>
        <h4 style={{ fontSize: "18px", fontWeight: "600" }}>सीमांकन के लिए पडोसी गांव को सूचना की पावती (2.7) (संलग्न 6)</h4>

        <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0" }}>
          <Button
            modifier="large"
            style={{ width: "40%", marginLeft: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
            onClick={() => {
              if (!Boolean(claim?.courtDocuments[7]?.title === "SDM_SUMMON_RESULT_8")) {
                setUploadType("MAIN_DOC");
                setDocName("SDM_SUMMON_RESULT_8");
                setCameraModalVis(true);
              } else {
                setPreviewDocModal(true);
                handleDocPreview(claim?.courtDocuments[7]?.storageUrl);
              }
            }}
          >
            {!Boolean(claim?.courtDocuments[7]?.title === "SDM_SUMMON_RESULT_8") ? (
              <>
                <Icon icon="md-camera" size={20} />
                {Boolean(
                  claim?.extraImageFormCountForSync &&
                    claim?.extraImageFormCountForSync["SDM_SUMMON_RESULT_8"] !== 0
                ) && (
                  <FontAwesomeIcon icon={faSync} size="lg" color="#fff" style={{ marginLeft: "10px" }} />
                )}
              </>
            ) : (
              "फोटो देखें"
            )}
          </Button>

          {Boolean(claim?.courtDocuments[7]?.title === "SDM_SUMMON_RESULT_8") && (
            <Button
              modifier="large"
              style={{ width: "40%", marginRight: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
              onClick={() => {
                setDocName("SDM_SUMMON_RESULT_8");
                setUploadType("MAIN_DOC");
                setCameraModalVis(true);
              }}
            >
              <FontAwesomeIcon icon={faCamera} size="lg" />
            </Button>
          )}
        </div>

        {claim?.courtDocuments[7]?.extraImages?.map((item, indd) => (
          <div key={`extra-image-${indd}`} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0" }}>
            <Button
              modifier="large"
              style={{ width: "40%", marginLeft: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
              onClick={() => {
                if (!(claim?.courtDocuments.length && claim?.courtDocuments[7]?.title === "SDM_SUMMON_RESULT_8")) {
                  setDocName("SDM_SUMMON_RESULT_8");
                  setCameraModalVis(true);
                } else {
                  setPreviewDocModal(true);
                  handleDocPreview(item?.url);
                }
              }}
            >
              {!Boolean(claim?.courtDocuments[7]?.title === "SDM_SUMMON_RESULT_8") ? (
                <FontAwesomeIcon icon={faCamera} size="lg" />
              ) : (
                "फोटो देखें"
              )}
            </Button>

            {claim?.courtDocuments[7]?.title === "SDM_SUMMON_RESULT_8" && (
              <Button
                modifier="large"
                style={{ width: "40%", marginRight: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
                onClick={() => {
                  setDocName("SDM_SUMMON_RESULT_8");
                  setCameraModalVis(true);
                  setFocusedExtraImageID(indd + 1);
                  setUploadType("UPDATE_EXTRA_IMAGE");
                }}
              >
                <FontAwesomeIcon icon={faCamera} size="lg" />
              </Button>
            )}
          </div>
        ))}

        <div style={{ display: "flex", justifyContent: "center", padding: "20px 0" }}>
          {Boolean(
            claim?.courtDocuments[7]?.title === "SDM_SUMMON_RESULT_8" ||
              Boolean(
                claim?.extraImageFormCountForSync &&
                  claim?.extraImageFormCountForSync["SDM_SUMMON_RESULT_8"] !== 0
              )
          ) && (
            <Button
              modifier="large"
              style={{ width: "40%", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
              onClick={() => {
                setDocName("SDM_SUMMON_RESULT_8");
                setCameraModalVis(true);
                setUploadType("NEW_EXTRA_IMAGE");
              }}
            >
              <FontAwesomeIcon icon={faPlus} size="lg" />
            </Button>
          )}
        </div>
      </div>

      {/* Form 9 Section */}
      <div style={{ borderTop: "1px solid #fff", padding: "20px" }}>
        <h4 style={{ fontSize: "18px", fontWeight: "600" }}>सीमांकन की कार्यवाही (2.9) (संलग्न 8)</h4>

        <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0" }}>
          <Button
            modifier="large"
            style={{ width: "40%", marginLeft: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
            onClick={() => {
              if (!Boolean(claim?.courtDocuments[8]?.title === "SDM_SUMMON_RESULT_9")) {
                setUploadType("MAIN_DOC");
                setDocName("SDM_SUMMON_RESULT_9");
                setCameraModalVis(true);
              } else {
                setPreviewDocModal(true);
                handleDocPreview(claim?.courtDocuments[8]?.storageUrl);
              }
            }}
          >
            {!Boolean(claim?.courtDocuments[8]?.title === "SDM_SUMMON_RESULT_9") ? (
              <>
                <Icon icon="md-camera" size={20} />
                {Boolean(
                  claim?.extraImageFormCountForSync &&
                    claim?.extraImageFormCountForSync["SDM_SUMMON_RESULT_9"] !== 0
                ) && (
                  <FontAwesomeIcon icon={faSync} size="lg" color="#fff" style={{ marginLeft: "10px" }} />
                )}
              </>
            ) : (
              "फोटो देखें"
            )}
          </Button>

          {Boolean(claim?.courtDocuments[8]?.title === "SDM_SUMMON_RESULT_9") && (
            <Button
              modifier="large"
              style={{ width: "40%", marginRight: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
              onClick={() => {
                setDocName("SDM_SUMMON_RESULT_9");
                setUploadType("MAIN_DOC");
                setCameraModalVis(true);
              }}
            >
              <FontAwesomeIcon icon={faCamera} size="lg" />
            </Button>
          )}
        </div>

        {claim?.courtDocuments[8]?.extraImages?.map((item, indd) => (
          <div key={`extra-image-${indd}`} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0" }}>
            <Button
              modifier="large"
              style={{ width: "40%", marginLeft: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
              onClick={() => {
                if (!(claim?.courtDocuments.length && claim?.courtDocuments[8]?.title === "SDM_SUMMON_RESULT_9")) {
                  setDocName("SDM_SUMMON_RESULT_9");
                  setCameraModalVis(true);
                } else {
                  setPreviewDocModal(true);
                  handleDocPreview(item?.url);
                }
              }}
            >
              {!Boolean(claim?.courtDocuments[8]?.title === "SDM_SUMMON_RESULT_9") ? (
                <FontAwesomeIcon icon={faCamera} size="lg" />
              ) : (
                "फोटो देखें"
              )}
            </Button>

            {claim?.courtDocuments[8]?.title === "SDM_SUMMON_RESULT_9" && (
              <Button
                modifier="large"
                style={{ width: "40%", marginRight: "20px", marginTop: "10px", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
                onClick={() => {
                  setDocName("SDM_SUMMON_RESULT_9");
                  setCameraModalVis(true);
                  setFocusedExtraImageID(indd + 1);
                  setUploadType("UPDATE_EXTRA_IMAGE");
                }}
              >
                <FontAwesomeIcon icon={faCamera} size="lg" />
              </Button>
            )}
          </div>
        ))}

        <div style={{ display: "flex", justifyContent: "center", padding: "20px 0" }}>
          {Boolean(
            claim?.courtDocuments[8]?.title === "SDM_SUMMON_RESULT_9" ||
              Boolean(
                claim?.extraImageFormCountForSync &&
                  claim?.extraImageFormCountForSync["SDM_SUMMON_RESULT_9"] !== 0
              )
          ) && (
            <Button
              modifier="large"
              style={{ width: "40%", backgroundColor: "#5C7232", color: "#fff", borderRadius: 20 }}
              onClick={() => {
                setDocName("SDM_SUMMON_RESULT_9");
                setCameraModalVis(true);
                setUploadType("NEW_EXTRA_IMAGE");
              }}
            >
              <FontAwesomeIcon icon={faPlus} size="lg" />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Stage3Content;
